import * as React from 'react';
import * as Edge from '../../../core';
import ExerciseResultLayout from '../exerciseResultLayout';
import { ExerciseMetadataService } from '../../../services/exerciseMetadataService';

export interface AlignmentResultsProps {
	results: Edge.Models.AlignmentExerciseResult;
	completeText: string;
	retry: () => void;
	complete: () => void;
	hideExerciseResults: boolean;
}

interface AlignmentResultsState {}

export class AlignmentResults extends React.PureComponent<AlignmentResultsProps, AlignmentResultsState> {
	constructor(props: AlignmentResultsProps) {
		super(props);
		this.state = {};
	}
	public render() {
		const { complete, completeText, results, retry, hideExerciseResults } = this.props;
		const exercise = ExerciseMetadataService.getMetadata(results);
		return (
			<ExerciseResultLayout
				className="alignment_results"
				exerciseName="Alignment"
				description={exercise && exercise.description}
				headerActions={
					<>
						<button className="cta_btn" onClick={retry}>
							Retry Exercise
						</button>
						<button className="cta_btn" onClick={complete}>
							{completeText}
						</button>
					</>
				}
				results={[results]}
				hideExerciseResults={hideExerciseResults}
			/>
		);
	}
}
export default AlignmentResults;
